var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('notifications',{attrs:{"group":"app","position":"top center","classes":"n-light","max":3,"width":500}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }